// extracted by mini-css-extract-plugin
module.exports = {"container":"dece2e673c--container--374qL","overlay":"dece2e673c--overlay--uKJkm","text":"dece2e673c--text--3zuIb"};